import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import { RadioButton } from "primereact/radiobutton";
import _ from "lodash";

//components
import ToastElement from "../../../Components/UiComponents/ToastElement";
import InputTextElement from "../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import AutoCompleteElement from "../../../Components/UiComponents/AutoCompleteElement";
import DropdownElement from "../../../Components/UiComponents/DropdownElement";
import { Tooltip } from 'primereact/tooltip';
//services
import { api } from "../../../Apis/interceptor";
import RadioElement from "../../../Components/UiComponents/RadioElement";
import { getContact, getAllAddress, createContact } from "../../../Services/addressService";
import { getCustomerFields } from '../../../Services/fieldsServices';
import { getBranchUser } from '../../../Services/userService';
import { list } from '../../../Services/branchService';
import { getCustomerDetails } from '../../../Services/clientService';

export default function AddContact(props) {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues,
        trigger,
        register
    } = useForm();
    const [visible, setVisible] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [titles, setTitles] = useState([
        { label: 'Mr.', value: 'Mr.' },
        { label: 'Mrs.', value: 'Mrs.' },
        { label: 'Ms.', value: 'Ms.' },
        { label: 'Miss.', value: 'Miss.' },
        { label: 'Mx.', value: 'Mx.' },
        { label: 'Dr.', value: 'Dr.' },
        { label: 'Prof.', value: 'Prof.' }
    ]);
    const [status, setStatus] = useState([
        { id: 0, label: 'Active', value: 'Active' },
        { id: 1, label: 'Inactive', value: 'Inactive' },
        { id: 2, label: 'Left The Company', value: 'Left The Company' }
    ]);
    const [businessUnit, setBusinessUnit] = useState([]);
    const [roles, setRoles] = useState([]);
    const [branchId, setBranchId] = useState(null);
    const [contactData, setContactData] = useState([])
    const [clientData, setClientData] = useState([]);
    const [orgData, setOrgData] = useState([]);
    const [addressLocation, setAddressLocation] = useState([]);
    const [selectedAssociated, setSelectedAssociated] = useState(props?.contactDetail?.associated === "Organisation" ? props?.contactDetail?.associated_name : '');
    const [associatedData, setAssociatedData] = useState([])
    const [coOrdinator, setCoOrdinator] = useState([]);
    const [selectedAssociatedClient, setSelectedAssociatedClient] = useState('');
    const [associatedDataClient, setAssociatedDataClient] = useState([])
    const [searchedData, setSearchedData] = useState('');
    const [cliRes, setCliRes] = useState([])
    const [orgRes, setOrgRes] = useState([])
    const [gdprTooltip, setGdprTooltip] = useState([])

    const toastRef = useRef();

    useEffect(() => {
        if (props?.contactDetail?.associated === "Client") {
            setSelectedAssociatedClient(props?.contactDetail?.associated_name || '');
        } else {
            setSelectedAssociatedClient('');
        }
    }, [props?.contactDetail?.associated, props?.contactDetail?.associated_name]);

    useEffect(() => {
        getCustomer();
        getBranchList();
        getCustomerDetail();
    }, [props?.customerId, props?.contactDetail]);

    useEffect(() => {
        getBranchUsers();
    }, [branchId]);

    const getCustomerDetail = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const response = await getCustomerDetails(props?.customerId);
            const clientModuleData = response?.data?.reference_data.filter(item => item.option_names === 'BusinessUnit');
            let data;
            if (clientModuleData) {
                data = clientModuleData[0]?.option_choice.filter(item => item.status === 'active');
            }
            setBusinessUnit(data)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getBranchList = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            // Ensure customerId is not null
            if (props?.customerId !== null) {
                // Fetch customer data from the server
                const customerDataResponse = await list(props?.customerId, 'branch_name', -1);
                // setBranchDetails(customerDataResponse?.data?.branch)
                setBranchId(customerDataResponse?.data?.branch[0]?._id)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getBranchUsers = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            // Ensure customerId is not null
            if (branchId !== null) {
                // Fetch customer data from the server
                const coordintor = await getBranchUser(props?.customerId, branchId);
                // setBranch(customerDataResponse.data[0]?.branch)
                const clonedData = coordintor?.data?.map((user) => ({
                    ...user,
                    label: `${user.firstname} ${user.surname}`,
                }));
                setCoOrdinator(clonedData);
                // setBranchDetails(customerDataResponse?.data?.branch)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getCustomer = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (props?.customerId !== null) {
                const response = await getCustomerFields(props?.customerId);
                let data = response.data.reference_data
                let state = data.filter(item => item.option_names === 'Roles')
                setRoles(state[0].option_choice)
                setGdprTooltip(response.data.tooltips?.organisation.others.address_and_contacts)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getContactDetails = async () => {
        if (props?.customerId !== null && props?.contactDetail?._id != null) {
            try {
                const resp = await getContact(props?.contactDetail?._id, props?.customerId);
                if (resp?.data?.message === "Available") {
                    setContactData(resp?.data?.contact[0])

                    if (resp?.data?.contact[0].associated === "Client") {
                        setClientData(resp?.data?.contact[0]);
                        await getFullAddress(resp?.data?.contact[0].associated_id)
                    }
                    else if (resp?.data?.contact[0].associated === "Organisation") {
                        setOrgData(resp?.data?.contact[0]);
                        await getFullAddress(resp?.data?.contact[0].associated_id)
                    }
                    else {
                        setAddressLocation([]);
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
        }
    }

    const getFullAddress = async (associated_id) => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (props?.customerId !== null) {
                const addRes = await getAllAddress(props?.customerId, associated_id);
                if (addRes.data?.message === "Available") {
                    setAddressLocation(addRes?.data?.address);
                }
                else {
                    setAddressLocation([]);
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const handleGetFramework = async () => {
        try {
            if (props.customerId === null && props.branch === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const OrgResponse = await api.get("/api/v1/getOrganisations", {
                params: { cust_id: props?.customerId, searchVal: selectedAssociated, branch_id: props?.branch?.branch_id },
            });
            setOrgRes(OrgResponse.data?.organisation);
            const AssociatedDisplayNames = OrgResponse.data?.organisation?.map(
                (org) => org.organisation_name
            );
            setAssociatedData(AssociatedDisplayNames);
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const handleGetClient = async (val) => {
        try {
            if (props.customerId === null && props.branch === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const searchText = val.query.trim();
            setSelectedAssociatedClient(searchText)
            const CliResponse = await api.get("/api/v1/getClients", {
                params: { cust_id: props?.customerId, searchVal: selectedAssociatedClient, branch_id: props?.branch?.branch_id },
            });
            setCliRes(CliResponse.data?.client)
            const AssociatedDisplayNames = CliResponse.data?.client?.map(
                (cli) => cli.client_name
            );
            setAssociatedDataClient(AssociatedDisplayNames);
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    // Function to create new prompt
    const onSubmit = async (promptData) => {
        let data = promptData;
        data.customer_id = props?.customerId
        data.name_title = promptData?.name_title
        data.first_name = promptData.first_name
        data.last_name = promptData.last_name
        data.role = promptData?.role?.label;
        data.email = promptData?.email.toLowerCase();
        data.team_member_contact = promptData?.phone_number
        data.status = promptData.status
        data.business_unit = promptData?.business_unit?.label
        data.consent_accept = promptData?.consent_accept
        data.address_id = promptData?.address_name?._id
        data.address_name = promptData?.address_name?.address_name
        data.website = promptData?.website
        data.associated = getValues('associated')
        if (getValues('associated') === "Client") {
            if (cliRes.length > 0) {
                data.associated_name = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?.client_name
                data.associated_id = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?._id
            }
            else {
                data.associated_name = props?.contactDetail?.associated_name
                data.associated_id = props?.contactDetail?.associated_id
            }
        }
        else if (getValues('associated') === "Organisation") {
            if (orgRes.length > 0) {
                data.associated_name = orgRes?.find((item) => item.organisation_name === selectedAssociated)?.organisation_name
                data.associated_id = orgRes?.find((item) => item.organisation_name === selectedAssociated)?._id
            }
            else {
                data.associated_name = props?.contactDetail?.associated_name
                data.associated_id = props?.contactDetail?.associated_id
            }
        }
        data.owner = promptData?.owner?.label
        data.full_name = `${data.first_name}  ${data.last_name}`

        try {
            const response = await createContact(data);
            if (response?.data.success) {
                if (response?.data.message === "Contact Already Exist") {
                    toastRef.current.showToast({
                        type: "error",
                        message: response?.data.message,
                    });
                }
                if (response?.data.message === "New Contact Created Successfully") {
                    toastRef.current.showToast({
                        type: "success",
                        message: response?.data.message,
                    });
                    closePopup();
                }
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: response?.data.message,
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const closePopup = () => {
        reset();
        setVisible(false);
        props.onHide();
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Dialog
                header={_.find(props.clientSectionsSummary, { section_name: "New Contact" })?.display_name}
                visible={props.visible}
                position={props.position}
                onHide={() => {
                    closePopup();
                }}
                footer={renderFooter()}
                className="width-40vw"
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {
                            _.find(props.addressContactFields, { field_name: "Title" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Title" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="name_title"
                                        control={control}
                                        defaultValue={props?.contactDetail?.name_title}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="name_title"
                                                {...field}
                                                name="label"
                                                options={(titles != undefined && titles.length > 0) ? titles : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('name_title', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "First Name" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "First Name" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="first_name"
                                        defaultValue={props?.contactDetail?.first_name}
                                        control={control}
                                        rules={{
                                            required: "First Name is required",
                                            minLength: {
                                                value: 2,
                                                message: "First Name must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "First Name cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "First Name contains invalid characters"
                                            }
                                        }}
                                        render={({ field }) => (
                                            <InputTextElement id="first_name" {...field} />
                                        )}
                                    />
                                    {errors?.first_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.first_name.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Last Name" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Last Name" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="last_name"
                                        defaultValue={props?.contactDetail?.last_name}
                                        control={control}
                                        rules={{
                                            required: "Last Name is required",
                                            minLength: {
                                                value: 2,
                                                message: "Last Name must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "Last Name cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "Last Name contains invalid characters"
                                            }
                                        }}
                                        render={({ field }) => (
                                            <InputTextElement id="last_name" {...field} />
                                        )}
                                    />
                                    {errors?.last_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.last_name.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Role" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Role" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="role"
                                        defaultValue={props?.contactDetail?.role}
                                        control={control}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="role"
                                                {...field}
                                                name="office_addr_contact"
                                                options={(roles != undefined && roles.length > 0) ? roles : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('role', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Mobile Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Mobile Number" }).display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        id='phone_number'
                                        name="phone_number"
                                        defaultValue={props?.contactDetail?.team_member_contact}
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Mobile number is not valid"
                                            }
                                        }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="team_member_contact" {...field} />
                                        )}
                                    />
                                    {errors?.phone_number && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.phone_number.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Email" })?.field_status &&
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Email" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        id="email"
                                        name="email"
                                        rules={{
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Invalid email format",
                                            },
                                        }}
                                        defaultValue={props?.contactDetail?.email}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="email" {...field} />
                                        )}
                                    />
                                    {errors?.email && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.email.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Status" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Status" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="status"
                                        control={control}
                                        defaultValue={props?.contactDetail?.status}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="status"
                                                {...field}
                                                name="label"
                                                options={(status != undefined && status.length > 0) ? status : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('status', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Associated to" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Associated to" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="associated"
                                        control={control}
                                        render={({ field }) => (
                                            <RadioElement
                                                id="associated"
                                                options={[
                                                    { key: "Client", name: "Stakeholder" },
                                                    // { key: "Organisation", name: "Organisation" },
                                                ]}
                                                value={getValues('associated')}
                                                onChangeRadio={(e) => { { setValue('associated', e) }; trigger('associated'); }}
                                                className="radio-group-class"
                                                setValue={setValue}
                                                register={register('associated')}
                                            // {...field}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {(getValues("associated") === "Organisation" &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        Organisation:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="associated_name"
                                        control={control}
                                        defaultValue={selectedAssociated}
                                        render={({ field }) => (
                                            <AutoCompleteElement
                                                value={selectedAssociated}
                                                onChangeValue={(e) => {
                                                    setValue('associated_name', e.value)
                                                    setSelectedAssociated(e.value)

                                                    getFullAddress(orgRes?.find((item) => item.organisation_name === e.value)?._id)
                                                }}
                                                placeholder="Search Organisation Name"
                                                suggestions={associatedData}
                                                autocomplete="off"
                                                completeMethod={handleGetFramework}
                                                className="w-full"
                                                isPurposeScore={true}
                                                {...field}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                        {(getValues("associated") === "Client" &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.fieldDetails, { module_name: "Clients" })?.display_name}
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="associated_name"
                                        control={control}
                                        render={({ field }) => (
                                            <AutoCompleteElement
                                                value={selectedAssociatedClient}
                                                onChangeValue={(e) => {
                                                    setValue('associated_name', e.value)
                                                    setSelectedAssociatedClient(e.value)
                                                    getFullAddress(cliRes?.find((item) => item.client_name === e.value)?._id)
                                                }}
                                                placeholder="Enter Stakeholder Name"
                                                suggestions={associatedDataClient}
                                                autocomplete="off"
                                                completeMethod={handleGetClient}
                                                className="w-full"
                                                isPurposeScore={true}
                                            // {...field}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                        {
                            _.find(props.commonFields, { field_name: "Location Name" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Location Name" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_name"
                                        control={control}
                                        defaultValue={
                                            addressLocation?.find((location) => location.address_name === props?.contactDetail?.address_name)
                                        }
                                        style={{ innerHeight: 10 }}
                                        render={({ field }) => (
                                            <DropdownElement
                                                onChange={(e) => { setValue('address_name', e.value) }}
                                                id="address_name"
                                                options={(addressLocation != undefined && addressLocation.length > 0) ? addressLocation : []}
                                                optionLabel="address_name"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Business Unit" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Business Unit" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="business_unit"
                                        control={control}
                                        defaultValue={props?.contactDetail?.business_unit}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="business_unit"
                                                {...field}
                                                name="label"
                                                options={(businessUnit != undefined && businessUnit.length > 0) ? businessUnit : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('business_unit', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }

                        {
                            _.find(props.addressContactFields, { field_name: "Co-ordinator" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Co-ordinator" })?.display_name}
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="owner"
                                        control={control}
                                        defaultValue={props?.contactDetail?.owner}
                                        render={({ field }) => {
                                            return (
                                                <SingleSelectElement
                                                    id="owner"
                                                    {...field}
                                                    name="firstname"
                                                    options={(coOrdinator != undefined && coOrdinator.length > 0) ? coOrdinator : []}
                                                    optionLabel="label"
                                                    placeholder="-- Please select --"
                                                    maxSelectedLabels={1}
                                                    onChangeValue={(e) => { setValue('owner', e.value) }}
                                                    className="w-full"
                                                />
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Website" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Website" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        id="website"
                                        name="website"
                                        defaultValue={props?.contactDetail?.website}
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value:
                                                    /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                                                message: "Invalid URL format",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <InputTextElement id="website" {...field} />
                                        )}
                                    />
                                    {errors?.website && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.website.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Comments" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "Comments" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0"></div>
                                <div className="col pr-0">
                                    <Controller
                                        name="comment"
                                        defaultValue={props?.contactDetail?.comment}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="comment" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "GDPR Consent Received" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.addressContactFields, { field_name: "GDPR Consent Received" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col-md-1 pl-0">
                                    {
                                        gdprTooltip?.gdpr_consent_received?.status == true &&
                                        <div>
                                            <Tooltip target=".custom-target-icon" />

                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                data-pr-tooltip={gdprTooltip?.gdpr_consent_received?.text}
                                                data-pr-position="right">
                                            </i>
                                        </div>
                                    }
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="consent_accept"
                                        control={control}
                                        defaultValue={props?.contactDetail?.consent_accept}
                                        render={({ field }) => (
                                            <>
                                                <RadioButton
                                                    inputId="admin-yes"
                                                    value={true}
                                                    onChange={(e) => {

                                                        field.onChange(e.value);

                                                    }}
                                                    checked={field.value === true}
                                                />
                                                <label
                                                    htmlFor="consent-yes"
                                                    className="p-radiobutton-label"
                                                >
                                                    Yes
                                                </label>
                                                <RadioButton
                                                    inputId="consent-no"
                                                    value={false}
                                                    onChange={(e) => {
                                                        field.onChange(e.value);

                                                    }}
                                                    checked={field.value === false}
                                                    className="ml-20"
                                                />
                                                <label htmlFor="consent-no" className="p-radiobutton-label">
                                                    No
                                                </label>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        }
                    </form>

                </div>
            </Dialog>
        </div>
    );
}